import { CSRF_COOKIE_NAME } from "./csrfCookieName";

export const deleteCookie = (
  cookieName: string, 
  path: string = '/', 
  domain?: string,
  secure: boolean = true,
  sameSite: 'Strict' | 'Lax' | 'None' = 'Strict',
): boolean => {
  try {
    const secureCookie = secure ? '; Secure' : '';
    let cookieString = `${cookieName}=; SameSite=${sameSite}${secureCookie}; Path=${path}; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    
    if (domain) {
      cookieString += `; Domain=${domain}`;
    }
    
    document.cookie = cookieString;
    
    return !document.cookie
      .split(';')
      .some(cookie => cookie.trim().startsWith(`${cookieName}=`));
      
  } catch (error) {
    console.error(`Failed to delete cookie ${cookieName}:`, error);
    return false;
  }
};

export const deleteCsrfCookie = (path: string = '/', domain?: string): boolean => {
  return deleteCookie(CSRF_COOKIE_NAME, path, domain);
};

export const forceDeleteCsrfCookie = (): boolean => {
  const path = '/';
  const currentDomain = window.location.hostname;
  let deleted = false;
  
  if (deleteCookie(CSRF_COOKIE_NAME, path)) {
    deleted = true;
  }
  
  if (deleteCookie(CSRF_COOKIE_NAME, path, currentDomain)) {
    deleted = true;
  }
  
  return deleted;
};
